// extracted by mini-css-extract-plugin
module.exports =  {"root":"T1Mk_SWA4rvgPjjeK3A1","description":"l2_NjBkIjzgRa8e8E2fr"};